import { Api } from "@/api";
import { PricingType, UserLoginType } from "@/DTO";
import { ConvertToRoleListType } from "@/api/auth";

export const GetPricingById = (user: UserLoginType, id: string) => {
  return new Promise<{
    data: PricingType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `pricing/${id}`,
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToPricingType(data.data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToPricingType = (item: any): PricingType => {
  return {
    id: item.id,
    size: item?.size,
    price: item?.price,
    bookbinding_price: item?.bookbinding_price,
    is_multi_color: item?.is_multi_color,
    created_at: item?.created_at
  };
};

